import { html, LitElement } from 'lit';

export default class AbrulesWebComponent extends LitElement {
  createRenderRoot() {
    return this;
  }

  static properties = {
    name: { type: String },
    data: { type: Object }
  };

  constructor() {
    super();
    this.name = 'Rules Web Component';
    this.data = {};
  }

  async connectedCallback() {
    super.connectedCallback();

    // console.log(this.data, 'BUENAS BUENAS');
  }

  render() {
    const { data } = this;

    const { rules } = data;

    return html`
      <section class="abrules-component">
        ${rules[0].children[0].text !== ''
    ? rules?.map(
      (item) => html`
                <p>
                  ${item.children?.map(
    (child) => html`
                      ${child.type === 'text'
    ? html`
                            <span
                              class="${child.bold ? 'font-b' : ''} ${child.italic
  ? 'font-i'
  : ''} ${child.underline ? 'font-u' : ''}"
                            >
                              ${child.text}
                            </span>
                          `
    : ''}
                      ${child.type === 'link'
    ? html`
                            <a href="${child.url}" target="_blank">${child.children[0].text}</a>
                          `
    : ''}
                    `
  )}
                </p>
              `
    )
    : html`
              <p>
                <b>Abbreviated rules.</b> Wafer sweet apple pie gummi bears muffin. Pie cookie
                brownie marzipan candy gummi bears. Cupcake gingerbread cake liquorice pudding apple
                pie sesame snaps.
              </p>
            `}
      </section>
    `;
  }
}

customElements.define('abrules-webcomponent', AbrulesWebComponent);
